function NotFound() {
  return (
    <h2>404</h2>
  );
}

export default NotFound;
